<template>
<div class="main">
    <img v-if="item && item.type == 'image'"
         :src="item.src"
         class="center"/>

    <iframe v-if="item && item.type == 'pdf'" :src="item.src" width="100%" height="100%" frameborder="0"></iframe>
</div>    
</template>
<script>
  import Vue from 'vue'

  import MainMediaProxy from "../../../../proxies/MainMediaProxy";

  export default {
    components: {
    },
    created: function () {

      new MainMediaProxy()
        .all()
        .then((response) => {
          const items = [...response.item.items]
          const item = items.find( item => item.active == true )
          if(item) {
            this.item = item
          } else {
            alert('표시가능한 매체가 없습니다.')
            this.$router.push('home')
          }

      })

    },
    methods: {

    },
    data() {
      return {
        item: null,
      }
    },
  }
</script>
<style scoped>
  .main { position: relative; width: 100%; height: 100vh; overflow: hidden;}
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 1280px;
  }
</style>
